<template>
  <subpage-shell
    :eyebrow="trans.get('landing.subpages.agb.eyebrow')"
    :title-prefix="trans.get('landing.subpages.agb.title_prefix')"
    :title-grad="trans.get('landing.subpages.agb.title_grad')"
    :title-suffix="trans.get('landing.subpages.agb.title_suffix')"
    :lede-prefix="trans.get('landing.subpages.agb.lede')"
    :show-jugendschutz="true"
    :show-cta="false"
    footer-variant="legal"
  >
    <main class="prose">
      <h2 id="praeambel">{{ trans.get('landing.subpages.agb.prose.h2_preamble') }}</h2>
      <p>
        Für alle Angelegenheiten, die den Schutz von Kindern betreffen, hat der Betreiber einen
        verantwortlichen Ansprechpartner benannt. Dieser kann unter
        <a href="mailto:support@viluu.de">support@viluu.de</a> kontaktiert werden.
      </p>
      <p>
        Die folgenden Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") regeln das
        Vertragsverhältnis zwischen der <strong>We2Gether GmbH</strong>, Friedrichstr. 171, 10117
        Berlin, eingetragen im Handelsregister Amtsgericht Charlottenburg unter HRB 223337 B
        (nachfolgend „Betreiber") und den Nutzern, die den Service des Betreibers nutzen
        (nachfolgend „Nutzer"). Sie definieren die Bedingungen, unter denen die Nutzung des Services
        erfolgt.
      </p>
      <p>
        Mit der Anmeldung auf <a href="https://www.viluu.de">www.viluu.de</a> (nachfolgend „Viluu")
        erklärt sich der Nutzer mit den nachfolgenden AGB einverstanden. Die AGB gelten unabhängig
        davon, ob die Nutzung kostenfrei oder kostenpflichtig erfolgt. Abweichende Bedingungen des
        Nutzers akzeptieren wir nicht. Dies gilt auch, wenn wir der Einbeziehung nicht ausdrücklich
        widersprechen.
      </p>
      <p>
        Viluu bietet eine interaktive Unterhaltungsplattform mit textbasierter Chatkommunikation.
        Teile dieser Chatkommunikation können automatisiert erzeugt oder unterstützt werden.
        Entsprechende Chatinhalte sind für den Nutzer während der Nutzung visuell eindeutig
        erkennbar dargestellt. Weitere Hinweise hierzu finden sich in § 1 und § 10 dieser AGB.
      </p>

      <h2 id="para1">{{ trans.get('landing.subpages.agb.prose.h2_1') }}</h2>
      <p>
        (1) Viluu ist eine reine Unterhaltungsplattform, die ihren Nutzern den Zugriff auf eine
        Datenbank mit fiktiven Profilen bietet. Diese Datenbank enthält Profile mit Fotos und
        Informationen, die ausschließlich zur Unterhaltung dienen. Angemeldete Nutzer können diese
        Profile und Informationen abrufen und mit den fiktiven Profilen interagieren. Viluu
        gestattet den Nutzern, auch von sich ein Profil zu erstellen und mit den fiktiven Profilen
        zu interagieren.
      </p>
      <p>
        (2) Zur besseren Transparenz für die Nutzer werden alle fiktiven Profile auf Viluu mit einem
        Herzsymbol
        <span
          class="vu-heart-inline"
          aria-hidden="true"
          >♥</span
        >
        gekennzeichnet.
      </p>
      <p>
        (3) Diese Profile dienen ausschließlich der Unterhaltung. Hinter ihnen stehen keine realen
        Personen, und ein persönlicher Kontakt oder ein Treffen ist nicht möglich.
      </p>
      <p>
        (4) Der Betreiber weist ausdrücklich darauf hin, dass jegliche Kommunikation mit diesen
        Profilen zu Unterhaltungszwecken erfolgt und keine echten Personen hinter den Profilen
        stehen.
      </p>
      <p>
        (5) Der Nutzer wird darüber informiert, dass Teile der textbasierten Kommunikation auf Viluu
        ganz oder teilweise durch automatisierte Systeme auf Basis künstlicher Intelligenz erzeugt
        oder unterstützt werden können. Diese Form der Chatkommunikation ist Bestandteil des
        Unterhaltungsangebots von Viluu.
      </p>
      <p>
        (6) Der Nutzer bestätigt mit seiner Registrierung und seiner gesonderten Zustimmung
        (Checkbox), dass er den Einsatz von KI-Systemen wie in Absatz 5 beschrieben zur Kenntnis
        genommen hat und hierin ausdrücklich einwilligt. Diese Zustimmung bezieht sich ausdrücklich
        auch auf die in § 10 beschriebenen Hinweise zur Chatdarstellung, insbesondere auf die dort
        erläuterte visuelle Kennzeichnung KI-unterstützter Chatabschnitte durch
        <span class="rose-highlight">rosa Hintergrundfarbe im Chatverlauf.</span>
      </p>

      <h2 id="para2">{{ trans.get('landing.subpages.agb.prose.h2_2') }}</h2>
      <p>
        (1) Die Nutzung des Services setzt die Registrierung des Nutzers auf Viluu voraus. Hierfür
        benötigt der Nutzer einen Usernamen, eine E-Mail-Adresse und ein Passwort. Die Registrierung
        wird unmittelbar nach Zugang der Daten per E-Mail durch den Betreiber bestätigt. Vor
        Abschluss der Registrierung wird der Nutzer auf die besonderen Hinweise zur Art der Profile
        sowie zur Darstellung der Chatkommunikation gemäß § 1 und § 10 hingewiesen.
      </p>
      <p>
        (2) Mit der Registrierung entsteht zunächst ein kostenloses Vertragsverhältnis zwischen dem
        Betreiber und dem angemeldeten Nutzer, das sich nach den Regelungen dieser AGB richtet.
      </p>
      <p>
        (3) Die Nutzung einiger Dienste auf Viluu ist entgeltpflichtig. Die Entrichtung der Entgelte
        ist nur mit Viluu-Coins möglich. Die Viluu-Coins kann der Nutzer zuvor zahlungspflichtig
        erwerben. Auf die Entgeltlichkeit wird der Nutzer vor der Nutzung entgeltlicher Dienste
        ausdrücklich unter Angabe der Anzahl der einzusetzenden Viluu-Coins hingewiesen. Die Nutzung
        ist erst nach aktivem Anklicken der Bestätigungsfläche möglich. Die Preise für Viluu-Coins
        richten sich nach der Menge der Viluu-Coins.
      </p>

      <h2 id="para2a">{{ trans.get('landing.subpages.agb.prose.h2_2a') }}</h2>
      <p>
        (1) Der Betreiber bietet den Nutzern die Möglichkeit, durch tägliches Einloggen in die App
        eine freiwillige Belohnung in Form von Gratis-Coins („Daily Bonus") zu erhalten. Ein
        Rechtsanspruch auf die Gewährung oder die Höhe dieses Bonus besteht nicht.
      </p>
      <p>
        (2) Um den Daily Bonus zu erhalten, muss der Nutzer die App aktiv öffnen und den Erhalt der
        Gratis-Coins innerhalb des angezeigten Pop-up-Fensters durch einen Klick bestätigen. Eine
        automatische Gutschrift ohne aktive Bestätigung oder eine rückwirkende Gutschrift für
        versäumte Tage ist ausgeschlossen.
      </p>
      <p>
        (3) Der Betreiber behält sich vor, das System der täglichen Belohnungen jederzeit ohne
        Angabe von Gründen zu ändern, zu pausieren oder vollständig einzustellen.
      </p>
      <p>
        (4) <strong>Deaktivierung bei Inaktivität:</strong> Die Bereitstellung des Daily Bonus ist
        ein Angebot für aktive Mitglieder des Viluu-Ökosystems. Der Betreiber behält sich vor, die
        Funktion zur Abholung des Daily Bonus für ein Nutzerkonto automatisch zu deaktivieren, wenn
        dieses über einen Zeitraum von mehr als 90 Tagen keine aktiven Transaktionen (wie z.&nbsp;B.
        den Erwerb von Coin-Paketen oder die Nutzung kostenpflichtiger Premium-Dienste) aufweist.
        Die Funktion kann durch eine erneute Transaktion im Shop wieder aktiviert werden.
      </p>

      <h2 id="para3">{{ trans.get('landing.subpages.agb.prose.h2_3') }}</h2>
      <p>
        (1) Der Nutzer kann Entgelte, soweit sie nicht über den Telefon- oder Mobilfunkanbieter
        abgerechnet werden, per herkömmlicher Überweisung, per Sofortüberweisung, per Paysafecard,
        per Lastschrift oder mit PayPal bezahlen. Viluu stellt ein Auswahlfenster bereit, aus dem
        heraus die gewünschte Zahlungsart angewählt werden kann. Alle Zahlungsmethoden mit Ausnahme
        der herkömmlichen Überweisung können direkt über die Plattform ausgeführt werden.
      </p>
      <p>
        (2) Bei Zahlungen per herkömmlicher Überweisung muss die Identifikationsnummer angegeben
        werden, die bei Auswahl der Zahlungsmethode eingeblendet wird. Bei Zahlung mit PayPal muss,
        wenn nicht der Link aus dem Zahlungsfenster von Viluu genutzt wird, der registrierte
        Nickname (Pseudonym) und der Name der Internetplattform
        <a href="https://www.viluu.de">www.viluu.de</a> angegeben werden. Ohne diese Angaben lässt
        sich die Zahlung nicht zuordnen. Dies kann dazu führen, dass der Nutzer die Dienste trotz
        Zahlung nicht nutzen kann.
      </p>
      <p>
        (3) Hat der Nutzer eine Zahlung angewiesen und dabei die notwendigen Daten nicht angegeben,
        ist eine Freischaltung der gebuchten Leistungen nur möglich, wenn der Nutzer den Betreiber
        in die Lage versetzt, die Einzahlung nachzuvollziehen, indem er dem Betreiber per E-Mail
        unter <a href="mailto:support@viluu.de">support@viluu.de</a> seine Daten (Nickname, Name der
        Internetseite) sowie den Namen des Kontoinhabers und das Überweisungsdatum mitteilt.
      </p>
      <p>
        (4) Kommt es zur Verpflichtung des Betreibers zur Rückerstattung von Zahlungen, so hat der
        Betreiber diese Verpflichtung innerhalb von 30 Tagen zu erfüllen. Der Nutzer ist
        verpflichtet, dem Betreiber seine Kontodaten (Kontoinhaber, Kontonummer, Bankleitzahl) bzw.
        bei PayPal-Zahlungen die bei PayPal hinterlegte E-Mail-Adresse mitzuteilen. Die
        Rückzahlungsfrist läuft nicht, solange der Nutzer diese Daten nicht mitgeteilt hat.
      </p>
      <p>
        (5) Der Nutzer kann gegen Ansprüche des Betreibers nur mit unbestrittenen oder rechtskräftig
        festgestellten Forderungen aufrechnen.
      </p>

      <h2 id="para4">{{ trans.get('landing.subpages.agb.prose.h2_4') }}</h2>
      <p>
        (1) Der Nutzer versichert, dass er nach den Gesetzen seines Staates über 18 Jahre alt und
        damit volljährig, sowie voll geschäftsfähig ist, um diese Vereinbarungen in allen Punkten
        rechtswirksam eingehen zu können. Weiter versichert der Nutzer, dass er als Privatperson
        handelt. Der Betreiber kann dafür einen Nachweis verlangen.
      </p>
      <p>
        (2) Der Nutzer ist verpflichtet, wahrheitsgemäße Angaben zu machen. Dies betrifft
        insbesondere den Vor- und Nachnamen, Anschrift und E-Mail-Adresse. Änderungen sind dem
        Betreiber unverzüglich mitzuteilen.
      </p>
      <p>
        (3) Die Anmeldung darf nur mit einem einzigen Profil erfolgen. Eine Mehrfachanmeldung darf
        der Betreiber zurückweisen.
      </p>
      <p>
        (4) Der Nutzer ist verpflichtet, Viluu nur für private Zwecke zu nutzen. Mit der Anmeldung
        versichert der Nutzer, keine geschäftlichen Absichten zu haben. Weiter versichert der
        Nutzer, Daten Dritter nicht zu kommerziellen Zwecken, einschließlich Werbezwecken zu
        verwenden.
      </p>
      <p>
        (5) Der Nutzer verpflichtet sich, Viluu nicht missbräuchlich zu nutzen oder den Betrieb zu
        stören. Ein Missbrauch oder eine Störung liegen vor, wenn der Nutzer:
      </p>
      <ul>
        <li>
          diffamierendes, anstößiges oder in sonstiger Weise rechtswidriges Material oder
          Informationen verbreitet oder von anderen Nutzern dieses erfragt,
        </li>
        <li>
          pornographische, rassistische, volksverhetzende oder vergleichbare Inhalte, sexuelle
          Dienstleistungen oder pornografisches Material zum Verkauf anbietet oder von anderen
          Nutzern erfragt,
        </li>
        <li>andere Nutzer belästigt oder bedroht,</li>
        <li>andere Nutzer in betrügerischer Absicht kontaktiert,</li>
        <li>
          Daten oder Inhalte einbringt, die Material enthalten, welches urheberrechtlich geschützt
          oder gewerbliche Schutzrechte oder sonstige Rechte (einschließlich Persönlichkeitsrechte)
          Dritter verletzt. Urheberrechtlich geschützte Daten oder Inhalte können nur eingebracht
          werden, wenn der Nutzer die erforderlichen Nutzungsrechte besitzt,
        </li>
        <li>
          Daten in das System einbringt, die einen Computervirus oder sonstige Schadsoftware
          enthalten,
        </li>
        <li>die Verfügbarkeit der Angebote für andere Nutzer beeinträchtigt,</li>
        <li>E-Mails für andere Nutzer abfängt oder dies versucht,</li>
        <li>
          E-Mails an andere Nutzer versendet, in denen er Waren, Dienstleistungen oder sonstige
          gewerbliche Zwecke anbietet. Eine Ausnahme liegt vor, wenn eine ausdrückliche Erlaubnis
          des Betreibers vorliegt,
        </li>
        <li>Massennachrichten versendet.</li>
      </ul>
      <p>
        Der Betreiber hält sich das Recht vor, den Inhalt jedweden Textes und eingesandter Fotos
        bzw. Grafik und sonstiger Dateien auf die Einhaltung von Gesetz und Recht zu überprüfen. Bei
        Bedarf kann der Inhalt geändert oder gelöscht werden. Dieser Vorbehalt begründet jedoch
        keine Überprüfungspflicht des Betreibers.
      </p>

      <h2 id="para4a">{{ trans.get('landing.subpages.agb.prose.h2_4a') }}</h2>
      <p>
        (1) Der Betreiber verpflichtet sich, in allen öffentlich zugänglichen Dokumenten,
        einschließlich dieser AGB, den Schutz von Kindern zu gewährleisten. Insbesondere wird
        jeglicher sexueller Missbrauch und jede Form der Ausbeutung von Kindern strikt verboten.
      </p>
      <p>
        (2) Nutzer verpflichten sich, keine Inhalte hochzuladen, zu verbreiten oder zu
        veröffentlichen, die Kinder gefährden oder gegen geltende Gesetze zum Schutz von Kindern
        verstoßen. Verstöße gegen diese Regelungen können zur sofortigen Sperrung des Kontos und
        Meldung an die zuständigen Behörden führen.
      </p>
      <p>
        (3) Der Betreiber wird Inhalte, die gegen diese Regelungen verstoßen, nach Kenntnisnahme
        umgehend entfernen.
      </p>

      <h2 id="para5">{{ trans.get('landing.subpages.agb.prose.h2_5') }}</h2>
      <p>
        (1) Der Nutzer hat die Möglichkeit, auf Viluu unter dem gewählten Nickname (Pseudonym) ein
        Profil zu hinterlegen. Die dabei angegebenen Daten können von anderen Nutzern auf Viluu
        eingesehen werden. Darüber hinaus wird der Betreiber die Profile auch zur Einsichtnahme
        durch nicht angemeldete Nutzer bereitstellen, um so für die Leistungen von Viluu zu werben.
        Siehe dazu auch die Datenschutzerklärung.
      </p>
      <p>
        (2) Der Betreiber stellt ein Verfahren bereit, über das Nutzer Feedback geben, Bedenken
        äußern oder rechtswidrige Inhalte melden können. Entsprechende Meldungen können über das
        Kontaktformular der Plattform oder per E-Mail erfolgen. Der Betreiber verpflichtet sich,
        eingehende Meldungen umgehend zu prüfen und geeignete Maßnahmen zu ergreifen.
      </p>
      <p>
        (3) Der Betreiber wird keinem anderen Nutzer von Viluu andere als die vom Nutzer in seinem
        Profil hinterlegten Daten mitteilen, insbesondere nicht den richtigen Namen, Anschrift und
        Rufnummern.
      </p>
      <p>
        (4) Der Betreiber weist darauf hin, dass eine Weitergabe der Pflichtdaten erfolgen kann,
        wenn diese aufgrund einschlägiger gesetzlicher Bestimmungen vorgeschrieben oder zulässig
        ist. Dies kann auch erfolgen, um Anforderungen staatlicher Ermittlungs-, Sicherheitsbehörden
        oder Finanzbehörden nachzukommen.
      </p>

      <h2 id="para6">{{ trans.get('landing.subpages.agb.prose.h2_6') }}</h2>
      <p>
        (1) Der Nutzer willigt durch seine Anmeldung darin ein, dass Betreiber seine
        personenbezogenen Daten, die er bei der Anmeldung und bei der Nutzung von Angeboten und
        Diensten der Internetseite <a href="https://www.viluu.de">www.viluu.de</a> eingibt, im
        Rahmen der vertraglichen Leistungserbringung speichert, verarbeitet und nutzt. Den
        gespeicherten Datensatz kann der Nutzer jederzeit im Login-Bereich abrufen, einsehen und
        ändern.
      </p>
      <p>
        (2) Der Nutzer willigt ferner darin ein, dass Betreiber Informationen sammelt, verwendet und
        analysiert, um die Funktionen der Plattform zu verbessern und den Nutzern einen besseren
        Service bieten zu können. Insbesondere ist Betreiber demnach dazu berechtigt, Pseudonyme der
        Nutzer mit deren Einverständnis an andere Nutzer weiterzugeben, was einen persönlichen
        Austausch von Nachrichten zwischen den Nutzern ermöglicht. Die Pseudonyme offenbaren jedoch
        nicht die Identität (Name, Adresse, Telefonnummer, E-Mail-Adresse) eines einzelnen Nutzers.
      </p>
      <p>
        (3) Der Nutzer willigt darin ein, dass Betreiber seine Daten an den Mobilfunkbetreiber des
        Nutzers oder andere Dritte weitergibt, soweit dies für die Abwicklung des Vertrags, zum
        Beispiel zur Abrechnung entgeltpflichtiger Leistungen erforderlich ist.
      </p>
      <p>
        (4) Der Nutzer willigt ferner darin ein, dass Betreiber seine Daten darüber hinaus mittelbar
        oder unmittelbar an Dritte weitergibt, die die Daten für Werbezwecke, insbesondere
        Werbeanrufe, Werbe-SMS und Werbe-E-Mails, verwenden.
      </p>
      <p>
        (5) Der Nutzer kann seine Einwilligung in die Datenspeicherung und Weitergabe sowie in die
        Nutzung seiner Profildaten auf anderen Internetplattformen jederzeit mit Wirkung für die
        Zukunft widerrufen. Er kann die Einwilligung in die Datenweitergabe zu Werbezwecken
        jederzeit separat von der sonstigen Einwilligung in die Datenweitergabe widerrufen. Er hat
        ferner ein jederzeitiges Recht auf kostenlose Auskunft, Berichtigung, Sperrung und ggf.
        Löschung seiner gespeicherten Daten. Der Widerruf bzw. die Geltendmachung der Rechte muss im
        Login-Bereich nach entsprechender Anmeldung erfolgen oder per E-Mail oder per Post an
        Betreiber (Kontaktdaten siehe Präambel dieser AGB) gesandt werden.
      </p>
      <p>
        (6) Für alle Angelegenheiten, die den Schutz von Kindern betreffen, hat der Betreiber einen
        verantwortlichen Ansprechpartner benannt. Dieser kann unter
        <a href="mailto:support@viluu.de">support@viluu.de</a> kontaktiert werden.
      </p>
      <p>
        (7) Der Betreiber bestätigt, dass er alle relevanten gesetzlichen Bestimmungen zum Schutz
        von Kindern einhält. Dies schließt die Pflicht ein, bestätigte Fälle von Darstellungen des
        sexuellen Missbrauchs von Kindern an die zuständigen Behörden, wie das National Center for
        Missing and Exploited Children (NCMEC) oder eine relevante lokale Behörde, zu melden.
      </p>
      <p>
        (8) Der Betreiber setzt auf der Internetseite
        <a href="https://www.viluu.de">www.viluu.de</a> an mehreren Stellen sogenannte Cookies ein.
        Cookies richten auf dem Rechner des Nutzers keinen Schaden an und enthalten keine Viren. Sie
        dienen dazu, das Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind
        kleine Textdateien, die auf dem Rechner des Nutzers abgelegt werden und die der Browser des
        Nutzers speichert. Der Nutzer kann in seinem Internetbrowser die Zulassung von Cookies und
        ihre Verwaltung regeln, ggf. die Zulassung sperren und dauerhafte Cookies löschen. Dann
        können aber unter Umständen nicht sämtliche Funktionen der Internetseite
        <a href="https://www.viluu.de">www.viluu.de</a> vollumfänglich genutzt werden.
      </p>

      <h2 id="para7">{{ trans.get('landing.subpages.agb.prose.h2_7') }}</h2>
      <p>
        (1) Der Nutzungsvertrag wird auf unbestimmte Zeit geschlossen. Der Nutzer und der Betreiber
        können den Vertrag jederzeit ohne Angabe von Gründen ohne Einhaltung einer Frist kündigen.
        Für den Betreiber gilt jedoch eine Kündigungsfrist von einem Monat, wenn der Nutzer
        Viluu-Coins erworben und noch nicht vollständig verbraucht hat.
      </p>
      <p>(2) Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt.</p>
      <p>
        (3) Die Kündigung bedarf der Schriftform an die We2Gether GmbH, Friedrichstr. 171, 10117
        Berlin.
      </p>
      <p>
        (4) Im Falle einer Kündigung ist diese nur wirksam, wenn in der Kündigungserklärung
        angegeben wird, dass sich die Kündigung auf die Internetseite
        <a href="https://www.viluu.de">www.viluu.de</a> bezieht. Weiter ist erforderlich, dass der
        Nickname oder die BenutzerID angegeben werden, um eine Zuordnung der Kündigung zu
        ermöglichen.
      </p>
      <p>
        (5) Der Betreiber wird auf Verlangen des Nutzers nach Ablauf des Vertrages sämtliche für den
        Nutzer gespeicherten Daten einschließlich Pseudonymen und Profilen löschen.
      </p>
      <p>
        (6) Falls der Nutzer kündigen oder gelöscht werden will bzw. Fragen an den Betreiber hat,
        ist im eingeloggten Zustand das „Kontakt-Formular" unten auf dieser Webseite zu nutzen.
      </p>

      <h2 id="para8">{{ trans.get('landing.subpages.agb.prose.h2_8') }}</h2>
      <p>
        <strong>Informationen zur Ausübung des Widerrufsrechts.</strong> Der Nutzer hat ein
        Widerrufsrecht, über das er wie folgt belehrt wird:
      </p>

      <div class="note">
        <p>
          <strong>{{ trans.get('landing.subpages.agb.prose.withdrawal_notice_title') }}</strong>
        </p>
        <p>
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu
          widerrufen.
        </p>
        <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.</p>
        <p>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (E-Mail:
          <a href="mailto:support@viluu.de">support@viluu.de</a>) mittels einer eindeutigen
          Erklärung (E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie
          können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht
          vorgeschrieben ist.
        </p>
        <p>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung
          des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
        </p>
      </div>

      <h3>{{ trans.get('landing.subpages.agb.prose.h3_withdrawal_consequences') }}</h3>
      <p>
        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen
        erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die
        sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene,
        günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn
        Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrages
        bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das
        Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde
        ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung
        Entgelte berechnet.
      </p>
      <p>
        Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, so
        haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt,
        zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags
        unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im
        Vertrag vorgesehenen Dienstleistungen entspricht.
      </p>
      <p>
        Zur Wahrung der Widerrufsfrist genügt die rechtzeitige Absendung des Widerrufs. Der Widerruf
        ist zu richten an unseren Support über das Kontaktformular unserer Webseite oder folgende
        E-Mail-Adresse: <a href="mailto:support@viluu.de">support@viluu.de</a>
      </p>
      <p><em>Ende der Widerrufsbelehrung.</em></p>

      <h3>{{ trans.get('landing.subpages.agb.prose.h3_withdrawal_form_note') }}</h3>
      <p>
        Füllen Sie dieses Formular nur aus und senden Sie es uns zurück, wenn Sie den Vertrag
        widerrufen möchten. Bitte beachten Sie, dass es für die eindeutige Zuordnung und schnelle
        Bearbeitung sehr hilfreich wäre, wenn Sie auch Ihre E-Mail-Adresse angeben, mit der Sie sich
        für unseren Service registriert haben.
      </p>

      <h3>{{ trans.get('landing.subpages.agb.prose.h3_withdrawal_form_template') }}</h3>
      <p>
        Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden
        Sie es zurück an: <a href="mailto:support@viluu.de">support@viluu.de</a>
      </p>
      <div class="note">
        <p>
          Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf
          der folgenden Waren (*)/ die Erbringung der folgenden Dienstleistung (*)
        </p>
        <p>
          Bestellt am (*) / erhalten am (*): __________________________<br />
          Name des/der Verbraucher(s): __________________________<br />
          Anschrift des/der Verbraucher(s): __________________________<br />
          Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier):
          __________________________<br />
          Datum: __________________________
        </p>
        <p class="form-note">(*) Unzutreffendes streichen</p>
        <p>
          <strong>Optionale Angabe:</strong> Ihre registrierte E-Mail-Adresse:
          __________________________
        </p>
      </div>

      <h2 id="para9">{{ trans.get('landing.subpages.agb.prose.h2_9') }}</h2>
      <p>
        (1) Der Betreiber haftet nicht dafür, dass innerhalb der Vertragsdauer eine erfolgreiche
        Kontaktvermittlung stattfindet. Weiter besteht auch keine Haftung für den Fall, dass während
        der Vertragsdauer überhaupt kein Kontakt zustande kommt.
      </p>
      <p>
        (2) Der Betreiber haftet nicht für die Richtigkeit und den Inhalt von Angaben, die Nutzer in
        den Anmelde- bzw. Profildaten oder an anderer Stelle auf
        <a href="https://www.viluu.de">www.viluu.de</a> machen.
      </p>
      <p>
        (3) Der Betreiber übernimmt keine Haftung für den eventuellen Missbrauch von Informationen.
        Weiter besteht keine Haftung dafür, dass Angaben und Informationen, die die Nutzer selbst
        Dritten zugänglich gemacht haben, von diesen missbraucht werden.
      </p>
      <p>
        (4) Der Betreiber haftet ebenfalls nicht für die unbefugte Kenntniserlangung von
        persönlichen Nutzerdaten durch Dritte (z.&nbsp;B. durch einen unbefugten Zugriff von
        „Hackern" auf die Datenbank). Eine Haftung des Betreibers besteht nur dann, wenn der Zugriff
        auf ein Unterlassen zumutbarer Sicherheitsmaßnahmen zurückzuführen ist.
      </p>
      <p>
        (5) Der Betreiber übernimmt keine Gewährleistung für die jederzeitige, ununterbrochene
        Erreichbarkeit des Services. Insbesondere haftet er nicht für Störungen, Ausfälle und
        Unterbrechungen aufgrund von höherer Gewalt oder von Ereignissen, die der Betreiber nicht zu
        vertreten hat. Der Betreiber haftet auch nicht für technisch bedingte
        Übertragungsverzögerungen oder Ausfälle. Aufgrund technischer Störungen oder auch
        notwendiger Wartungsarbeiten kann es zu einer vorübergehenden Unterbrechung des Services
        kommen.
      </p>
      <p>
        (6) Der Betreiber haftet nur für Schäden bei der Verletzung von Leben, Körper oder
        Gesundheit, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung des
        Betreibers oder gesetzlichen Vertretern bzw. Erfüllungsgehilfen beruhen. Im Übrigen ist die
        Haftung ausgeschlossen.
      </p>

      <h2 id="para10">{{ trans.get('landing.subpages.agb.prose.h2_10') }}</h2>
      <p>
        (1) Der Betreiber setzt zur Unterhaltung der Nutzer Profile von fiktiven Personen ein. Diese
        Profile dienen ausschließlich der Unterhaltung. Die professionellen Chat-Partner, die diese
        Profile betreiben, geben sich als diese fiktive Person aus. Alle Äußerungen und alle von
        diesen Profilen angegebenen Daten (persönliche und Kontaktdaten) sind Erfindungen der
        Chat-Partner. Somit verbergen sich nicht hinter allen Profilen reale Personen. Mit diesen
        Profilen sind daher keine realen Treffen möglich.
      </p>
      <p>
        (2) Soweit KI-unterstützte Chatkommunikation stattfindet, wird diese im Chatverlauf durch
        eine deutlich erkennbare visuelle Kennzeichnung in Form einer rosa Hintergrundfarbe
        dargestellt. Diese visuelle Darstellung dient der unmittelbaren Erkennbarkeit automatisiert
        erzeugter oder unterstützter Chatinhalte für den Nutzer.
      </p>
      <p>
        (3) Der Nutzer erkennt an, dass rosa hinterlegte Chatabschnitte Inhalte darstellen, die ganz
        oder teilweise durch KI-Systeme erzeugt oder unterstützt wurden und somit nicht
        ausschließlich menschlichen Ursprungs sind.
      </p>
      <p>
        (4) Die Kennzeichnung durch rosa Hintergrundfarbe ist Bestandteil der vertraglichen Leistung
        und dem Nutzer vor Vertragsabschluss in klarer Form erläutert worden, insbesondere über die
        gesonderte Zustimmung (Checkbox) bei der Registrierung.
      </p>
      <p>
        (5) Die in Absatz 2 beschriebene visuelle Kennzeichnung stellt sicher, dass der Nutzer
        jederzeit erkennen kann, ob er mit automatisiert erzeugten oder unterstützten Chatinhalten
        interagiert. Diese Form der Kennzeichnung erfüllt die Transparenzanforderungen an
        KI-gestützte Kommunikation vor und während der Nutzung des Dienstes.
      </p>

      <h2 id="para11">{{ trans.get('landing.subpages.agb.prose.h2_11') }}</h2>
      <p>
        (1) Die vertraglichen Vereinbarungen der Vertragspartner unterliegen dem Recht der
        Bundesrepublik Deutschland.
      </p>
      <p>
        (2) Der Betreiber behält sich das Recht vor, die AGB und die Nutzungsbedingungen jederzeit
        zu ändern. Mit der Anwendung der geänderten AGB und Nutzungsbedingungen auf bereits vor der
        Änderung geschlossene Verträge erklärt sich der Nutzer hiermit einverstanden, wenn er nach
        Hinweis auf die Änderung durch den Betreiber nicht innerhalb einer Frist von zwei Wochen
        widerspricht. Die Frist beginnt mit dem Tag, der auf die Änderungsmitteilung erfolgt. Die
        Änderungsmitteilung muss nochmals den Hinweis auf die Möglichkeit, Frist und Folgen eines
        Widerspruchs bzw. Folgen des Unterlassens eines Widerspruchs enthalten. Sie kann per E-Mail
        an die vom Nutzer angegebene E-Mail-Adresse erfolgen. Widerspricht der Nutzer der Geltung
        der neuen AGB und Nutzungsbedingungen, hat der Betreiber ein Sonderkündigungsrecht.
      </p>
      <p>
        (3) Vertragsabänderungen, Ergänzungen und Nebenabreden bedürfen, sofern in diesen AGB nichts
        anderes bestimmt ist, zu ihrer Wirksamkeit der Textform beider Seiten. Das
        Textformerfordernis gilt auch für den Verzicht auf dieses Textformerfordernis.
      </p>
      <p>
        (4) Sollte eine Bestimmung dieser Vertragsbedingungen unwirksam sein oder werden, so berührt
        dies die Wirksamkeit der übrigen Bestimmungen nicht. An die Stelle der unwirksamen
        Bestimmung tritt stattdessen eine dem Zweck der Bestimmung entsprechende oder nahekommende,
        welche die Parteien zur Erreichung des gleichen wirtschaftlichen Ergebnisses vereinbart
        hätten, wenn sie die Unwirksamkeit der Bestimmung gekannt hätten.
      </p>

      <p class="agb-end">Ende der AGB</p>
    </main>
  </subpage-shell>
</template>

<script>
import SubpageShell from './SubpageShell.vue';

export default {
  name: 'AgbPage',
  components: { SubpageShell },
};
</script>
<style scoped lang="scss">
.vu-heart-inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #1a0c14;
  color: #fff;
  border-radius: 5px;
  font-size: 12px;
  line-height: 1;
  vertical-align: -4px;
  margin: 0 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.rose-highlight {
  background-color: var(--pink);
  color: #fff;
  padding: 0 4px;
  border-radius: 4px;
  /* When the highlight wraps across lines, give each line its own padding and
     rounded corners instead of only padding the very start and end. */
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}
</style>
